import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import MediumModal from "../../../../components/modals/MediumModal";
import {
  closeLabOrderLinkResultModal,
  openLabOrderGeneralResultModal,
} from "../../../../redux/actions/modals";
import { sendLabOrderResult } from "../../../../redux/actions/orders";
import toaster from "../../../../utils/toaster";
const SendLabLinkResultComponent = (props) => {
  const dispatch = useDispatch();
  const { link_lab_result_order_open, link_result_lab_order } = useSelector(
    (state) => state.modals
  );
  const { send_lab_order_result_waiting } = useSelector(
    (state) => state.orders
  );
  const [links, setLinks] = useState({ next_index: 0, links: [] });
  const [linksLab, setLinksLab] = useState([]);
  const [link, setLink] = useState("");
  const submit = () => {
    linksLab.forEach((element) => {
      if (element.trim() === "") {
        toaster.error("لینکها به درستی وارد نشده است.");
        return;
      }
    });
    if (linksLab.length === 0) {
      toaster.warning("ابتدا لینک مورد نظر را اضافه نمایید.");
      return;
    }
    let body = {
      method: "links",
      links: linksLab,
    };
    dispatch(sendLabOrderResult(link_result_lab_order.id, body));
  };

  const removedFromLinks = (link) => {
    const removedArrayLinks = linksLab.filter((element) => element !== link);
    setLinksLab(removedArrayLinks);
  };

  const renderLinks = () => {
    if (linksLab !== null && linksLab.length !== 0) {
      return linksLab.map((link, index) => {
        return (
          <div
            className="col-lg-12 col-md-12 col-sm-12 file-uploaded-drug-holder pt-0 mt-3"
            key={index}
          >
            <a
              className="btn btn-sm btn-primary text-13"
              target={"_blank"}
              href={link}
            >
              {link}
            </a>
            <div
              onClick={() => {
                removedFromLinks(link);
              }}
            ></div>
          </div>
        );
      });
    }
  };
  useEffect(() => {
    setLinksLab([]);
    setLink("");
  }, [props]);

  return (
    <MediumModal
      header="ارسال لینک مشاهده نتیجه آزمایش"
      show={link_lab_result_order_open}
      closeFunction={closeLabOrderLinkResultModal}
    >
      <div className="lab-direct-result-form-holder">
        <div className="form-holder">
          <div className="form-group row">
            <label className="col-sm-12 col-form-label">
              لینک‌های مشاهده نتایج
            </label>
            <div className="col-sm-12" key={1}>
              <input
                type="text"
                className="form-control"
                value={link}
                onChange={(e) => {
                  setLink(e.target.value);
                }}
              />
            </div>
            <button
              className="btn btn-small btn-outline-primary btn-add-link justify-center"
              onClick={() => {
                let current_links = links.links;
                current_links[links.next_index] = "";
                setLinksLab([...linksLab, link]);
                setLink("");
              }}
            >
              افزودن لینک
            </button>
          </div>
          {
            <div className="col-lg-12 lab-result-images-holder">
              <div className="row">
                {linksLab.length > 0 && <span>لینک های اضافه شده </span>}
                {renderLinks()}
              </div>
            </div>
          }
          <div className="form-group row sampling-order-action-buttons mb-0">
            <div className="col-sm-6 mb-3">
              <CustomButton
                action={submit}
                loading={send_lab_order_result_waiting}
                content={"تایید و ارسال"}
                type={"success"}
                block={true}
                textWhite={true}
              />
            </div>
            <div className="col-sm-6 mb-3">
              <button
                className="btn btn-small btn-outline-black full-width"
                onClick={() => {
                  dispatch(closeLabOrderLinkResultModal());
                  dispatch(
                    openLabOrderGeneralResultModal(link_result_lab_order)
                  );
                  setLinksLab([]);
                  setLink("");
                }}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      </div>
    </MediumModal>
  );
};
export default SendLabLinkResultComponent;
